import Swiper, { Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";

function logosSlider() {
  const isPresent = document.querySelector(".logos-slider");
  if (!isPresent) {
    return;
  }

  const slider = new Swiper(".logos-slider", {
    modules: [Navigation, Autoplay],
    loop: true,
    autoplay: true,
    slidesPerView: 5,
    keyboard: {
      enabled: true,
    },
    autoHeight: false,
    navigation: {
      nextEl: ".logos-slider-next",
      prevEl: ".logos-slider-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 3,
      },
      // when window width is >= 480px
      700: {
        slidesPerView: 4,
      },
      // when window width is >= 640px
      1024: {
        slidesPerView: 5,
      },
    },
  });
}

export { logosSlider };

function feedbackSlider() {
  const isPresent = document.querySelector(".feedback-slider");
  if (!isPresent) {
    return;
  }

  const slider = new Swiper(".feedback-slider", {
    modules: [Navigation, Autoplay],
    loop: true,
    autoplay: true,
    slidesPerView: "auto",
    centeredSlides: true,
    keyboard: {
      enabled: true,
    },
    speed: 800,
    autoHeight: false,
    // setWrapperSize: true,
    navigation: {
      nextEl: ".feedback-slider-next",
      prevEl: ".feedback-slider-prev",
    },
  });
}

export { feedbackSlider };
